<div class="auth-layout">
  <header class="auth-layout__topbar">
    <img class="auth-layout__logo" src="assets/images/Logo-Volta.svg" alt="Volta" />
  </header>

  <main class="auth-layout__body">
    <div class="auth-layout__column">
      <ng-content></ng-content>
    </div>
  </main>

  <footer class="auth-layout__footer">
    <span class="auth-layout__rights">
      {{ 'authentication.rights_reserved' | translate: { year: currentYear } }}
    </span>

    <div class="auth-layout__language" *ngIf="showLanguageSelector" #languageSelector>
      <button
        type="button"
        class="auth-layout__language-trigger"
        [attr.aria-expanded]="isDropdownOpen"
        [attr.aria-label]="'language.select' | translate"
        aria-haspopup="listbox"
        (click)="toggleDropdown()"
      >
        <span class="auth-layout__language-code">{{ currentLanguage }}</span>
        <ui-svg-icon
          svgIcon="chevron-down"
          size="small"
          [rotated]="isDropdownOpen"
          customClass="auth-layout__language-chevron"
        ></ui-svg-icon>
      </button>

      <ul class="auth-layout__language-menu" *ngIf="isDropdownOpen" role="listbox">
        <li *ngFor="let language of languages" role="option" [attr.aria-selected]="language.code === currentLanguage">
          <button
            type="button"
            class="auth-layout__language-option"
            [class.is-selected]="language.code === currentLanguage"
            (click)="switchLanguage(language.code)"
          >
            {{ language.labelKey | translate }}
          </button>
        </li>
      </ul>
    </div>
  </footer>
</div>
